import solicitudes from './solicitudes.js';
import { getApi } from '../config/getApiUrl';

const apiUrl = (path) => `${getApi()}${path}`;
const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('auth')}`,
    'Content-Type': 'application/json',
});

// ─── Productos por tipo ───────────────────────────────────────────────────────

export const getMateriasPrimas = async (id_usuario) => {
    const res = await solicitudes.fetchRegistrosAuth(`/produccion/materias-primas/${id_usuario}`);
    return res?.data || res || [];
};

export const getProductosTerminados = async (id_usuario) => {
    const res = await solicitudes.fetchRegistrosAuth(`/produccion/terminados/${id_usuario}`);
    return res?.data || res || [];
};

// ─── Recetas ─────────────────────────────────────────────────────────────────

export const getRecetas = async (id_usuario) => {
    const res = await solicitudes.fetchRegistrosAuth(`/produccion/recetas/${id_usuario}`);
    return res?.data || res || [];
};

export const crearReceta = (id_usuario, datos) =>
    solicitudes.postRegistroAuth(`/produccion/recetas/${id_usuario}`, datos);

export const actualizarReceta = (id_receta, id_usuario, datos) =>
    solicitudes.patchRegistroAuth(`/produccion/recetas/${id_receta}/${id_usuario}`, datos);

export const toggleReceta = (id_receta, id_usuario, activo) =>
    solicitudes.patchRegistroAuth(`/produccion/recetas/${id_receta}/estado/${id_usuario}`, { activo });

export const eliminarReceta = async (id_receta, id_usuario) => {
    const res = await fetch(apiUrl(`/produccion/recetas/${id_receta}/${id_usuario}`), {
        method: 'DELETE',
        headers: authHeader(),
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Error ${res.status}`);
    }
    return true;
};

// ─── Órdenes de Producción ───────────────────────────────────────────────────

export const getOrdenes = async (id_usuario, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await solicitudes.fetchRegistrosAuth(`/produccion/ordenes/${id_usuario}${qs ? '?' + qs : ''}`);
    return res?.data || res || [];
};

export const getOrdenDetalle = async (id_orden) => {
    const res = await solicitudes.fetchRegistrosAuth(`/produccion/ordenes/${id_orden}/detalle`);
    return res?.data || res;
};

export const crearOrden = async (id_usuario, datos) => {
    const res = await fetch(apiUrl(`/produccion/ordenes/${id_usuario}`), {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(datos),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
    // response: { success: true, id_orden, costo_total, costo_por_unidad, precio_sugerido, stock_info }
    return data;
};

export const ejecutarOrden = async (id_orden, id_usuario) => {
    const res = await fetch(apiUrl(`/produccion/ordenes/${id_orden}/ejecutar/${id_usuario}`), {
        method: 'PATCH',
        headers: authHeader(),
        body: JSON.stringify({}),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
    return data;
};

export const cancelarOrden = async (id_orden, id_usuario) => {
    const res = await fetch(apiUrl(`/produccion/ordenes/${id_orden}/cancelar/${id_usuario}`), {
        method: 'PATCH',
        headers: authHeader(),
        body: JSON.stringify({}),
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Error ${res.status}`);
    }
    return true;
};
